import Elyon81 from '../Elyon 8/Elyon 8 (1).webp'
import Elyon82 from '../Elyon 8/Elyon 8 (2).webp'
import Elyon83 from '../Elyon 8/Elyon 8 (3).webp'
import Elyon84 from '../Elyon 8/Elyon 8 (4).webp'
import Elyon85 from '../Elyon 8/Elyon 8 (5).webp'
import Elyon86 from '../Elyon 8/Elyon 8 (6).webp'
import Elyon87 from '../Elyon 8/Elyon 8 (7).webp'
import Elyon88 from '../Elyon 8/Elyon 8 (8).webp'
import Elyon89 from '../Elyon 8/Elyon 8 (9).webp'




const Elyon8images =[ Elyon81,Elyon82,Elyon83,Elyon84,Elyon85,Elyon86,Elyon87,Elyon88,Elyon89
]

export default Elyon8images;